import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { LicenseStateService } from '../../services/license-state-service/license-state-service';

/**
 * Permanent strip shown while the school the user is working in has no valid license. Deliberately
 * not a toast: the user needs the explanation to stay on screen for as long as every write is
 * refused.
 */
@Component({
  selector: 'app-read-only-banner',
  imports: [MatButton, MatIcon, RouterLink],
  template: `
    @if (licenseState.readOnly()) {
      <div
        class="flex items-center gap-3 px-8 py-3 bg-error-container text-on-error-container border-b border-error/30"
      >
        <mat-icon class="shrink-0">lock</mat-icon>
        <p class="text-sm flex-1">
          <span class="font-semibold">Škola nemá platnou licenci.</span>
          Data zůstávají přístupná ke čtení, ale nelze je upravovat. Pro obnovení licence nás prosím
          kontaktujte.
        </p>
        @if (licenseState.currentSchoolId(); as id) {
          <a matButton="outlined" [routerLink]="['/schools', id, 'licenses']">Zobrazit licenci</a>
        }
      </div>
    }
  `,
})
export class ReadOnlyBanner {
  readonly licenseState = inject(LicenseStateService);
}
